import React from "react";
import {isRSAA, RSAA} from "redux-api-middleware/es";
import {setNotification} from "../notifications/notifications-actions";
import {authInit as authInitAction, expired, signIn} from "./auth-actions";
import {getValidToken} from "../token";
import {push} from 'connected-react-router'
import Cookies from "universal-cookie";

const cookies = new Cookies();

export const authInit = (store) => {
    store.dispatch(authInitAction('api/v1'));
};

export const authApiWrapper = (store) => (next) => (action) => {
    if(!isRSAA(action)) {
        return next(action);
    }

    const {auth, ...rsaaAction} = action;

    if (!auth) {
        return next(rsaaAction);
    }

    let token = cookies.get('_ctt') || ReactOnRails.authenticityToken();

    let modifiedHeaders = { ...rsaaAction[RSAA].headers, 'X-CSRF-Token': token };

    return (async() => {
        const response = await next({ ...action, [RSAA]: { ...rsaaAction[RSAA], headers: modifiedHeaders }});
        return response;
    })();
};

export const apiUnauthorizedWrapper = ({dispatch}) => next => (action) => {
    if(!isRSAA(action)) {
        return next(action);
    }

    const {onFailure, ...rsaaAction} = action;
    if(!onFailure) {
        return (async() => {
            const response = await next(rsaaAction);
            if(response.error) {
                if (response.payload.status === 401) {
                    dispatch(expired());
                }

                if (response.payload.status === 403) {
                    dispatch(authInitAction('api/v1'));
                    dispatch(push('/forbidden'));
                }
            }
            return response;
        })();
    }

    return (async() => {
        const response = await next(rsaaAction);
        if(response.error && onFailure) {
            dispatch(onFailure);
        } else if(onSuccess) {
            dispatch(onSuccess);
        }
        return response;
    })();
};
